import * as React from 'react';
import { Router, Switch, Route } from 'react-router-dom'
import PermisosApp from '../components/permisos.json'
import Publicaciones from './publicaciones'
import MisPedidos from './mispedidos'
import EditarPedido from '../pages/editarPedido'
import { createBrowserHistory } from 'history'
import CargarPedidoManager from '../pages/cargarPedidoManager';

export default class Pedidos extends React.Component {
    constructor(props){
      super(props);
      this.state={
        render:[],
        results: [],
        links: [],
        accordion: false,
        urlRedirect:""
      }
    }

    history = createBrowserHistory()
    
    setLinks = this.props.setLinks

    componentDidMount() 
    {
      document.title = "Publicaciones"

      this.setState({
        urlRedirect: "/Pedidos"
      })
    }

    allowedLinks = (arrLinks) => {
      const Links = JSON.parse(localStorage.infoToken)["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]
      const allowedLinks = arrLinks.map((e, index, self) => {
        const { path } = e.props
        if (path.toLowerCase().includes("pedidos")) {
          const initSlice = path.indexOf('/', path.indexOf('/') + 1)
          const stringlink = path.slice(initSlice + 1, undefined)
          var permisosUser = [];
          if (typeof Links !== 'undefined') {
            permisosUser = Links.filter(e => e.includes(stringlink))
          }
          if(permisosUser.length > 0) {
            return e
          }
        } else {
          return e
        }
      })
      return allowedLinks
    }

    componentWillUnmount() {
      this.props.hideMenu(true)
    }

    render(){
      const {urlRedirect} = this.state;
      return (
        <React.Fragment>
        <Router history={ this.props.props.history } > 
            <Switch>
              <Route exact path={urlRedirect} render={ (props) => {
                const Links = JSON.parse(localStorage.infoToken)["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]
                if (typeof Links !== 'undefined') 
                {
                  const LinksApp = Links.filter(e => PermisosApp.includes(e))
                  var primerlink = [];
                
                    primerlink = LinksApp.filter(e => e.toLowerCase().indexOf("pedidos.publicaciones") !== -1)[0] 
                              || LinksApp.filter(e => e.toLowerCase().indexOf("pedidos.mispedidos") !== -1)[0] 
                
                  if(primerlink && primerlink.toLowerCase().indexOf("pedidos.publicaciones") !== -1) {
                    return <Publicaciones hideMenu={this.props.hideMenu} props={props} />
                  } else if (primerlink && primerlink.toLowerCase().indexOf("pedidos.mispedidos") !== -1) {
                    return <MisPedidos hideMenu={this.props.hideMenu} props={props}  />
                  } else {
                    return <div></div>
                  }
                } else {
                  return <div></div>
                }
              } }/>
              {this.allowedLinks([
                <Route key={0} exact path={urlRedirect+"/Publicaciones"} render={ (props) => <Publicaciones props={props} hideMenu={this.props.hideMenu} /> }/>,
                <Route key={1} exact path={urlRedirect+"/MisPedidos"} render={ (props) => <MisPedidos props={props} hideMenu={this.props.hideMenu} /> }/>,
                <Route key={2} exact path={urlRedirect+"/CargarPedido"} render={ (props) => <CargarPedidoManager props={props} hideMenu={this.props.hideMenu}/>} />,
                <Route key={3} exact path={urlRedirect+"/EditarPedido"} render={ (props) => <EditarPedido props={props} />} />,
               ])}
            </Switch>
          </Router>
        </React.Fragment>
        )
    }
} 